import coupleSmiling2 from './couple-smiling-2.webp';
import coupleSmiling from './couple-smiling.webp';
import manWithGlasses from './man-with-glasses.webp';
import manWithHeadphones from './man-with-headphones.webp';
import manWithHeadphones2 from './man-with-headphones-2.webp';
import menSmiling from './men-smiling.webp';
import womanSmiling from './woman-smiling.webp';
import womanSmiling2 from './woman-smiling-2.webp';
import womanWithHeadphones from './woman-with-headphones.webp';
import womanWithHeadphonesAndLaptop from './woman-with-headphones-and-laptop.webp';
import womanWithHeadphones2 from './woman-with-headphones-2.webp';
import womanWithHeadphones3 from './woman-with-headphones-3.webp';
import womenSmiling from './women-smiling.webp';
import discount from './discount.webp';
import duration from './duration.webp';
import steps from './steps.webp';
import contact from './contact.webp';
export var pageImages = {
    coupleSmiling2: coupleSmiling2,
    coupleSmiling: coupleSmiling,
    manWithGlasses: manWithGlasses,
    manWithHeadphones: manWithHeadphones,
    manWithHeadphones2: manWithHeadphones2,
    menSmiling: menSmiling,
    womanSmiling: womanSmiling,
    womanSmiling2: womanSmiling2,
    womanWithHeadphones: womanWithHeadphones,
    womanWithHeadphonesAndLaptop: womanWithHeadphonesAndLaptop,
    womanWithHeadphones2: womanWithHeadphones2,
    womanWithHeadphones3: womanWithHeadphones3,
    womenSmiling: womenSmiling,
    discount: discount,
    duration: duration,
    steps: steps,
    contact: contact,
};
